export const environment = {
    production: false,
    endpoint: 'https://localhost:7296/api',
    version: '1.4.0'
}